module.exports = __webpack_public_path__ + "static/media/010A57F3-BCE8-44F8-9FC0-5B1FF195FDFA.bfb23801.JPG";